import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import AdminModelTypes from './pages/AdminModelTypes';
import CreateModelType from './pages/CreateModelType';
import ModelTypeDetail from './pages/ModelTypeDetail';
import CreateModel from './pages/CreateModel';
import ModelDetails from './pages/ModelDetails';
import Home from './pages/Home';
import { useUser } from './context/UserContext';
import EditModel from './pages/EditModel';
import Settings from './pages/Settings';
import Dashboard from './pages/Dashboard';
import DealMap from './pages/DealMap';
import { useAuth0 } from '@auth0/auth0-react';
import { BACKEND_URL } from './utils/constants';
import UserMgmt from './pages/UserMgmt';
import UserIssues from './pages/UserIssues';
import Team from './pages/Team';
import AcceptInvite from './pages/AcceptInvite';
import AdminActivity from './pages/AdminActivity';
import AdminFirms from './pages/AdminFirms';
import { getPendingInvite } from './utils/invite';


const AppRoutes: React.FC = () => {
  const { user } = useUser();
  const adminEmails = process.env.REACT_APP_ADMIN_EMAILS?.split(',') || [];
  const location = useLocation();
  const navigate = useNavigate();

  // Back from the Auth0 login with an invitation link captured beforehand
  // (utils/invite.ts): finish on the accept page, not the models page.
  useEffect(() => {
    if (location.pathname === '/' && getPendingInvite()) {
      navigate('/accept-invite', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <Routes>
      {adminEmails.includes(user?.email || '') && (
        <>
          <Route path="/admin/model-types/create-new-model" element={<CreateModelType />} />
          <Route path="/admin/model-types/:id" element={<ModelTypeDetail />} />
          <Route path="/admin/model-types" element={<AdminModelTypes />} />
          <Route path="/admin/users" element={<UserMgmt />} />
          <Route path="/admin/activity" element={<AdminActivity />} />
          <Route path="/admin/firms" element={<AdminFirms />} />
        </>
      )}
      {/* Always register issues route to avoid 'No routes matched' warning; gate access inline */}
      <Route
        path="/admin/issues"
        element={adminEmails.includes(user?.email || '') ? <UserIssues /> : <Navigate to="/" replace />}
      />
      <Route path="/" element={<Home />} />
      <Route path="/create-model" element={<CreateModel />} />
      <Route path="/models/:id" element={<ModelDetails />} />
      <Route path="/edit-model/:id" element={<EditModel />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/map" element={<DealMap />} />
      <Route path="/team" element={<Team />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
    </Routes>
  );
};

export default AppRoutes;